export default function($) {
  var $nav = $('#js-table-of-contents')

  if (!$nav.length) {
    return
  }

  // Make nav sticky
  var sticky = new Waypoint.Sticky({
    element: $nav
  })

  // Create one waypoint for every section
  var waypoints = $('h2').waypoint({
    handler: function(direction) {
      // Highlight nav button corresponding to the current waypoint
      $('.table-of-contents-item-current').removeClass('table-of-contents-item-current')

      var anchor_id

      if (direction === 'up') {
        if (this.previous() !== null) {
          anchor_id = this.previous().element.id
        }
      } else {
        if (this.element !== null) {
          anchor_id = this.element.id
        }
      }

      $("a[href='#" + anchor_id + "']").addClass('table-of-contents-item-current')
    },
    offset: 50,
    continuous: false
  })
}
